var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.219,
    height: 68.219,
    viewBox: "0 0 68.219 68.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3415",
    "data-name": "Path 3415",
    d: "M32.7,46.342H39.52v6.822H32.7Zm0-27.288H39.52V39.52H32.7ZM36.075,2A34.11,34.11,0,1,0,70.219,36.109,34.093,34.093,0,0,0,36.075,2Zm.034,61.4A27.288,27.288,0,1,1,63.4,36.109,27.28,27.28,0,0,1,36.109,63.4Z",
    transform: "translate(-2 -2)",
    fill: "#c60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.77c1e1e97364217d91859b720838c310.svg";
export { ForwardRef as ReactComponent };